import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import swal from 'sweetalert2';
import { AuthServiceService } from "../../../../shared-services/auth-service.service";
import { SignInDto } from '../../../../dtos/sign-in.dto';
import { FormGroup } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { from } from 'rxjs';
import { of } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { skip } from 'rxjs/operators';
import { UserDataService } from '../../data-storage/user-data.service';
import { UserService } from '../../services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';
import { Router } from '@angular/router';
import { GlobalDataService } from '../../../../shared-services/global-data.service';
import { UserDto } from '../../../../dtos/userDto';

@Component({
    selector: 'app-login-window',
    templateUrl: './login-window.component.html',
    styleUrls: ['./login-window.component.scss']
})
export class LoginWindowComponent implements OnInit, AfterViewInit {

    constructor(private authService: AuthServiceService,
                private userService: UserService,
                private userDataService: UserDataService,
                private translateService: TranslateService,
                private router: Router,
                private globalDataService: GlobalDataService) {
    }

    @ViewChild("loginForm")
    private loginForm;

    @ViewChild('loginRef', {static: true})
    loginElement: ElementRef;

    @Input()
    loginTrigger: boolean;
    @Output()
    loginTriggerChange: EventEmitter<any> = new EventEmitter<any>();

    notAuthenticated: boolean;

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        combineLatest([this.translateService.get("TRANS_REMOTE_LOGIN.TRANS_HEAD")
            , this.translateService.get("TRANS_REMOTE_LOGIN.TRANS_LOGIN_BUTTON")])
            .subscribe((value) => {
                swal({
                    title: '<strong>' + value[0] + '</strong>',
                    html: '&nbsp;',
                    showCloseButton: true,
                    showCancelButton: false,
                    focusConfirm: false,
                    confirmButtonText:
                        value[1],
                    confirmButtonAriaLabel: 'Thumbs up, great!',
                    cancelButtonAriaLabel: 'Thumbs down',
                    preConfirm: () => {
                        this.loginWithForm()
                            .subscribe((validated) => {
                                if (validated) {
                                    setTimeout(() => {
                                        this.afterLoginNavigation();
                                    })
                                } else {
                                    this.notAuthenticated = true;
                                }
                            })
                        return false;
                    }
                }).then((reason) => {
                    setTimeout(() => {
                        this.afterLoginNavigation();
                    })
                });
                setTimeout(() => {
                    //swal2-content
                    const loginElement = this.loginForm.nativeElement;
                    document.getElementById('swal2-content').appendChild(loginElement);
                    loginElement.style.display = 'block';
                }, 50)
            })

    }

    loginWithForm(): Observable<boolean> {
        let signInDto = new SignInDto();
        const behaviorSubject = new BehaviorSubject(this.notAuthenticated);
        signInDto.usernameOrEmail = (<HTMLInputElement>document.getElementById("username")).value;
        signInDto.password = (<HTMLInputElement>document.getElementById("password")).value;
        if (signInDto.usernameOrEmail || signInDto.password) {
            this.notAuthenticated = false;
            this.userService.validateUser(signInDto)
                .then(noValid => {
                    behaviorSubject.next(!noValid);
                })
        } else {
            this.notAuthenticated = true;
            this.userService.logout();
            behaviorSubject.next(!this.notAuthenticated)
        }
        return behaviorSubject.pipe(
            skip(1)
        );
    }


    socialValidation(noValid) {
        this.notAuthenticated = noValid;
        if (!noValid) {
            this.afterLoginNavigation();
        } else {
            this.userService.logout();
        }
    }

    private afterLoginNavigation() {
        swal.close();
        this.loginTrigger = false;
        this.loginTriggerChange.emit(this.loginTrigger);
        const user: UserDto = this.userDataService.getUser();
        if (user.virtualTourType === 'GUIDE') {
            this.router.navigate(
                [this.globalDataService.getRemoteContext() + '/' + this.globalDataService.getCurrentLang() + '/profile']
            );
        }
    }

}
